import { type MutableRefObject, useCallback, useEffect, useRef, useState } from 'react';

export const useIsStickyObserver = (ref: MutableRefObject<HTMLDivElement | null>) => {
  const [isSticky, setIsSticky] = useState(false);
  const observer = useRef<IntersectionObserver | null>(null);

  const intersectCallback: IntersectionObserverCallback = useCallback(([entry]) => {
    // Only isSticky when at the top of the window.
    if (!entry.isIntersecting && entry.boundingClientRect.top < entry.boundingClientRect.height) {
      setIsSticky(true);
    }

    if (entry.isIntersecting) {
      setIsSticky(false);
    }
  }, []);

  useEffect(() => {
    if (ref.current && 'IntersectionObserver' in window) {
      const marginTop = 1;
      // Margin required to cover full width of sticky element
      const marginHorizontal = 20;

      observer.current = new IntersectionObserver(intersectCallback, {
        threshold: 1,
        rootMargin: `-${marginTop}px ${marginHorizontal}px 0px ${marginHorizontal}px`,
      });

      observer.current.observe(ref.current);
    }

    return () => observer.current?.disconnect();
  }, [ref, intersectCallback]);

  return {
    isSticky,
  };
};
